export default {
  getReports: state => state.reports,
  getReportTypes: state => state.reportTypes,
}
